// extracted by mini-css-extract-plugin
module.exports = {"container":"UserNotifications__container___LJv-N","item":"UserNotifications__item___NVANa","content":"UserNotifications__content___5ASb6"};